import { useState } from "react";
import { captchaRequired, getCaptchaToken } from "../CaptchaBox";

const API = process.env.REACT_APP_BACKEND_URL;

export const SelfUnblock = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("email");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const post = async (path, body) => {
    const r = await fetch(`${API}/api/security/unblock/${path}`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Something went wrong — try again");
    return d;
  };

  const request = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      let captcha_token;
      if (captchaRequired()) {
        try { captcha_token = await getCaptchaToken("gfy_unblock"); }
        catch { throw new Error("Security check could not load — please retry"); }
      }
      const d = await post("request", { email, captcha_token });
      setMsg(d.message); setStep("code");
    }
    catch (ex) { setErr(ex.message); }
    finally { setBusy(false); }
  };

  const verify = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { const d = await post("verify", { email, code }); setMsg(d.message); setStep("done"); setTimeout(() => window.location.reload(), 1200); }
    catch (ex) { setErr(ex.message); }
    finally { setBusy(false); }
  };

  const input = "w-full bg-transparent border border-white/15 px-3 py-2 font-body text-sm text-gf-text placeholder:text-gf-muted/60 focus:outline-none focus:border-gf-primary transition-colors";
  const btn = "font-mono text-[10px] uppercase tracking-widest px-4 py-2 border transition-colors disabled:opacity-40";

  return (
    <div className="mt-8 border border-white/10 p-5 text-left" data-testid="self-unblock-box">
      <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-gf-primary">Registered with Growthifye?</p>
      <p className="font-body text-xs text-gf-muted mt-1">Staff, client-portal users and alert subscribers can lift this block themselves with a one-time code sent to their registered e-mail. Protected by reCAPTCHA.</p>
      {step === "email" && (
        <form onSubmit={request} className="mt-4 flex gap-2">
          <input data-testid="self-unblock-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="your registered e-mail" className={input} />
          <button data-testid="self-unblock-send-btn" disabled={busy} className={`${btn} border-gf-primary text-gf-primary hover:bg-gf-primary hover:text-gf-bg`}>
            {busy ? "Sending…" : "Send code"}
          </button>
        </form>
      )}
      {step === "code" && (
        <form onSubmit={verify} className="mt-4 flex gap-2">
          <input data-testid="self-unblock-code-input" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} required value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="6-digit code" className={`${input} tracking-[0.4em] font-mono`} />
          <button data-testid="self-unblock-verify-btn" disabled={busy || code.length !== 6} className={`${btn} border-gf-primary text-gf-primary hover:bg-gf-primary hover:text-gf-bg`}>
            {busy ? "Checking…" : "Unblock"}
          </button>
        </form>
      )}
      {msg && <p data-testid="self-unblock-message" className="font-body text-xs text-emerald-300 mt-3">{msg}</p>}
      {err && <p data-testid="self-unblock-error" className="font-body text-xs text-red-400 mt-3">{err}</p>}
      {step === "code" && (
        <button type="button" data-testid="self-unblock-resend-btn" onClick={() => { setStep("email"); setMsg(""); setCode(""); }}
          className="font-mono text-[9px] uppercase tracking-widest text-gf-muted mt-3 hover:text-gf-text transition-colors">Use a different e-mail</button>
      )}
    </div>
  );
};
